export const isCalidad = (role) => {
    return role==='Calidad';    
}